import React, { Component } from 'react';
import ReactToolTip from 'react-tooltip';

class ListExport extends Component {
  constructor( props ) {
    super( props );
    this.state = {
      caption: props.caption === undefined ? 'Export' : props.caption,
      data: props.data === undefined ? [] : props.data,
      visible: props.visible === undefined ? false : props.visible,
      width: props.width === undefined ? '100px' : props.width,
      tooltiptext: props.tooltiptext === undefined ? '' : props.tooltiptext
    };
    this.onExport = this.onExport.bind( this );
  }

  componentWillReceiveProps( nextProps ) {
    this.setState( {
      caption: nextProps.caption === undefined ? 'Export' : nextProps.caption,
      data: nextProps.data === undefined ? [] : nextProps.data,
      visible: nextProps.visible === undefined ? false : nextProps.visible,
      width: nextProps.width === undefined ? '100px' : nextProps.width,
      tooltiptext: nextProps.tooltiptext === undefined ? '' : nextProps.tooltiptext
    } );
  }

  onExport( e ) {
    if( this.props.onExport !== undefined ) {
      this.props.onExport( this.state.data );
    }
  }

  render() {
    if( this.state.visible === true ) {
      const tooltiptext = this.state.tooltiptext === '' ? this.state.caption : this.state.tooltiptext;
      return (
        <span className="list-export">
          <button data-tip={tooltiptext} data-for='export-tooltip' className="list-export-button" onClick={this.onExport} style={{'width': this.state.width}} >
            <i className="icon-fontello-export" />&nbsp;&nbsp;<span>{this.state.caption}</span>
          </button>
          <ReactToolTip id="export-tooltip" offset={{'top': 10}} type="info" />
        </span>
      );
    } else {
      return '';
    }
  }
}

export default ListExport;



// WEBPACK FOOTER //
// ./src/presentation/ListExport.js